import { get, writable } from 'svelte/store'

import { capitalizeFirst } from '$lib/functions/formatters'
import { RecurringInterval } from '$lib/types/subscription_types'

export function getSubscriptionIntervalDisplayName(interval: string, toUpper = false) {
	let textInterval = interval
	if (interval == RecurringInterval.Month) textInterval = 'monthly'
	if (interval == RecurringInterval.Year) textInterval = 'yearly'
	if (toUpper) textInterval = capitalizeFirst(textInterval)
	return textInterval
}


// Navigation Subscription Path
const storeSuccessPath = writable('')

export const setSuccessPath = (path = '') => {
	storeSuccessPath.set(path)
}

export const getSuccessPath = (): string => {
	return get(storeSuccessPath)
}
